import * as React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import { Typography, Box } from "@mui/material";
import ReactPlayer from "react-player/lazy";

export default function ServiceVideo() {
	return (
		<Card
			sx={{
				width: { xs: 290, md: 600 },
				height: { xs: 450, md: 400 },
				gap: { xs: 0, md: 2 },
				borderRadius: 8,
				p: { xs: "0px", md: 2 },
				// py: { xs: 2, md: 2 },

				bgcolor: "#E5F3FF",
			}}
		>
			<CardContent>
				<Typography
					gutterBottom
					fontWeight={600}
					fontSize={{ xs: 22, md: 32 }}
					px={{ xs: 2, md: 0 }}
				>
					{"Handpicked Winning Products"}
				</Typography>
				<Typography
					fontWeight={400}
					fontSize={{ xs: 16, md: 18 }}
					sx={{ color: "#667085" }}
					px={{ xs: 2, md: 0 }}
				>
					Get instant access to top-selling, high-demand products with low
					competition, carefully researched to help you start selling
					profitably.
				</Typography>
			</CardContent>

			<Box sx={{}}>
				<ReactPlayer
					width={{ xs: "260px", md: "504px" }}
					height="200px"
					url='https://www.youtube.com/watch?v=KCOieD4cFpE"'
				/>
			</Box>
		</Card>
	);
}
